import * as React from 'react';
import { SessionServerSelectors, SessionSiteSelectors, SessionUserSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { openReactConfirmationDialog } from '../../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../../commonInfra/dialogs/style/TabDialogWidth';
import { toNativePromise } from '../../../../commonInfra/utils/QUtils';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { useSelector } from '../../utils';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export type RunNowSectionProps = SiteSettingsForSiteAdminProps<'runNowEnabled'>;

export const RUN_NOW_SECTION_CHECKBOX = 'run-now-enable-checkbox';

export function RunNowSection(): JSX.Element {
  if (!useShowSettingsSection()) {
    return null;
  }

  return (
    <SettingsSection title={Messages.runNowEnabledSettingHeader()} description={Messages.runNowEnabledSettingDescription()} testId={'run-now-setting-section'}>
      <FormikCheckbox
        label={Messages.runNowGlobalToggleDialogCheckboxLabel()}
        name="settings.runNowEnabled"
        testId={RUN_NOW_SECTION_CHECKBOX}
        beforeChange={openConfirmationDialog}
      />
    </SettingsSection>
  );
}

function openConfirmationDialog(event: React.ChangeEvent<HTMLInputElement>) {
  const isRunNowEnabled = event.target.value === 'true';
  const dialogPromiseResult = openReactConfirmationDialog({
    title: isRunNowEnabled
      ? Messages.runNowDisable()
      : Messages.runNowEnable(),
    message: isRunNowEnabled
      ? Messages.runNowDisableSiteConfirmationText()
      : Messages.runNowEnableSiteConfirmationText(),
    actionName: Messages.yes(),
    action: () => Promise.resolve(),
    dialogWidth: TabDialogWidth.width375px,
    paramsForAction: null,
  }).result;
  return toNativePromise(dialogPromiseResult);
}

function useShowSettingsSection(): boolean {
  const isServerAdmin = useSelector(SessionUserSelectors.isSessionServerAdmin);
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  const isSiteAdmin = useSelector(SessionSiteSelectors.isSessionSiteAdmin);

  const isAllowedToChangeSetting = isServerAdmin || (isOnlineEnvironment && isSiteAdmin);
  return FeatureFlags.enableRunNowEnabled && isAllowedToChangeSetting;
}

export const RunNowSpec = componentRegistryEntry({
  name: 'RunNowSection',
  component: RunNowSection
});
